import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children, user: userProp }) => {
  const token = localStorage.getItem('token');
  const storedUser = localStorage.getItem('user');
  const isAuthenticated = token && (storedUser || userProp);

  if (!isAuthenticated) {
    return <Navigate to="/signin" replace />;
  }

  return children;
};

export default ProtectedRoute;
